module.exports = __webpack_public_path__ + "3721f036c34423092fa1386ef70ce76f.png";